import { IDynamicFormItemProps } from ".";

import Text from "components/Text/Text";
import replaceWyshwareUri from "utils/replaceWyshwareUri";
import { translateTextTag } from "utils/translateTextTag";

import c from "classnames";
import { kebabCase } from "lodash-es";
import "./TextItem.scss";

export function TextItem({ item }: IDynamicFormItemProps<"text">) {
  const { color, html, text, typography, style, backgroundColor } = item.content;
  const translatedTypography = translateTextTag(typography);

  const bgColor = style === "pill" && !backgroundColor ? "primary" : backgroundColor;

  const classes = c(
    "dynamic-form-item form-item--text",
    `color-${kebabCase(color)}`,
    `${typography}-dynamic-form__text`,
    {
      [`bgcolor-${kebabCase(bgColor)}`]: bgColor,
      [`form-item--${kebabCase(style)}`]: style,
    }
  );

  if (html) {
    return (
      <Text
        className={classes}
        dangerouslySetInnerHTML={{ __html: replaceWyshwareUri(text) }}
        tag={translatedTypography}
      />
    );
  }

  return (
    <Text className={classes} tag={translatedTypography}>
      {text}
    </Text>
  );
}
